import {
    NOTIFICATION_ADD,
    NOTIFICATION_REMOVE,
} from 'constants/notification'


export const info = (text, cooldown = false, position) => addNotification(text, 'info', cooldown, position)
export const success = (text, cooldown = false, position) => addNotification(text, 'success', cooldown, position)
export const warning = (text, cooldown = false, position) => addNotification(text, 'warning', cooldown, position)
export const danger = (text, cooldown = false, position) => addNotification(text, 'danger', cooldown, position)
export const primary = (text, cooldown = false, position) => addNotification(text, 'primary', cooldown, position)

export const addNotification = (text, type = 'primary', cooldown = false, position='tr') => (dispatch, state) => {
    let icon = false
    const obj = {
        text: text,
        type: type,
        position: position,
    }
    if (icon)
        obj.icon = icon
    dispatch(pushNotification(obj))
    if (cooldown)
        setTimeout(() => dispatch(removeNotification(state().notification.length - 1)), cooldown * 1000);
}


export function pushNotification(notification) {
    return { type: NOTIFICATION_ADD, payload: notification }
}
export const removeNotification = (id) => ({ type: NOTIFICATION_REMOVE, payload: id })


// WEBPACK FOOTER //
// ./src/actions/notification.js